import { useTheme } from 'styled-components';
import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import StyledSvg from '@sdk/components/ui/StyledSvg';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import TimeIconSvg from '@web/assets/svg/Icons/32/time-gray.svg';
import { useBackTooSoonModal } from '@web/timeClock/BackTooSoonModal/backTooSoonModal.hooks';
import { Props } from '@web/timeClock/BackTooSoonModal/backTooSoonModal.types';

const BackTooSoonModal = ({ shift, shouldShow, onClose }: Props) => {
  const theme = useTheme();
  const { isVisible, handleClose, getBreakDurationMessage } = useBackTooSoonModal({
    shift,
    shouldShow,
    onClose,
  });

  if (!isVisible) {
    return null;
  }

  return (
    <InfoModal
      fullScreen
      bodyPadding={0}
      buttonsMargin={0}
      zIndex={2000}
      titleText={gettext('End break')}
      titleIcon={<StyledSvg svg={TimeIconSvg} color={theme.colors[ThemeColorType.warning]} />}
      titleThemeColor={ThemeColorType.warning}
      buttonText={gettext('Close')}
      dismiss={handleClose}>
      <Row pTop={20} pRight={20} pLeft={20}>
        <Text14 themeColor={ThemeColorType.gray}>
          {gettext('You are back too soon!')}&nbsp;{getBreakDurationMessage()}
        </Text14>
      </Row>
    </InfoModal>
  );
};

export default BackTooSoonModal;
